
import React from 'react';
import { getNavigationStats } from '@/utils/navigationMonitor';

interface NavigationTabProps {
  stats: ReturnType<typeof getNavigationStats>;
  setStats: React.Dispatch<React.SetStateAction<ReturnType<typeof getNavigationStats>>>;
}

const NavigationTab: React.FC<NavigationTabProps> = ({ stats, setStats }) => {
  return (
    <div className="space-y-2">
      <div>
        <span className="text-gray-500 dark:text-gray-400">Navigations: </span>
        {stats.navigationsCount}
      </div>
      
      <div>
        <span className="text-gray-500 dark:text-gray-400">Currently Navigating: </span>
        {stats.currentlyNavigating ? (
          <span className="text-yellow-500">{stats.currentPath}</span>
        ) : (
          <span className="text-green-500">No</span>
        )}
      </div>
      
      {stats.errors.length > 0 && (
        <div>
          <span className="text-gray-500 dark:text-gray-400">Navigation Errors: </span>
          <span className="text-red-500">{stats.errors.length}</span>
          <div className="mt-1 max-h-20 overflow-y-auto text-xs">
            {stats.errors.map((error, index) => (
              <div key={index} className="text-red-500 mb-1 p-1 border border-red-200 bg-red-50 dark:bg-red-900/20 rounded">{error}</div>
            ))}
          </div>
        </div>
      )}
      
      <div className="mt-2 pt-2 border-t border-gray-200 dark:border-gray-700">
        <button
          onClick={() => {
            // Reset navigation errors
            const newStats = getNavigationStats();
            newStats.errors = [];
            setStats({...newStats});
          }}
          className="text-xs px-2 py-1 bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 rounded"
        >
          Clear Navigation Errors
        </button>
      </div>
    </div>
  );
};

export default NavigationTab;
